import {AUTH} from "@/config/enum";

export default [
    {to: "/backend/dashboard", text: "首页面板", icon: "wq-dashboard"},
    {to: "/backend/tenant", text: "平台租户管理", icon: "wq-chanpin", auth: [AUTH.SUPER_ADMIN], children: [
        {to: "/backend/tenant/list", text: "租户管理"}
    ]},
    {to: "/backend/agent", key : "/backend/agent", text: "代理商管理", icon: "wq-agent", auth: [AUTH.ADMIN, AUTH.SUPER_ADMIN, AUTH.AGENT], children: [
            {to: "/backend/agent/list", text: "代理商管理"},
            {to: "/backend/agent/recharge/add", text: "代理商充值记录"},
            {to: "/backend/agent/recharge/deduct", text: "代理商扣值记录"},
            {to: "/backend/agent/return/list", key: "return", text: "代理商返佣记录"}
    ]},
    {to: "/backend/customer", text: "客户管理",icon: "wq-customer", children: [
            {to: "/backend/customer/list", text: "客户管理"},
            {to: "/backend/customer/recharge/add", text: "客户充值记录"},
            {to: "/backend/customer/recharge/deduct", text: "客户扣值记录"},
            {to: "/backend/customer/consume", text: "客户消耗记录"},
            {to: "/backend/customer/give", text: "客户赠送记录"},
            {to: "/backend/customer/remit", text: "客户汇款"},
            {to: "/backend/customer/authentication", text: "客户认证"},
            {to: "/backend/customer/login/log", text: "客户登录日志", auth: [AUTH.ADMIN, AUTH.SUPER_ADMIN, AUTH.AGENT]},
            {to: "/backend/customer/product/price", key: "customerPriceConfig", text: "客户价格方案", auth: AUTH.AGENT, domestic: false},
    ]},
    {to: "/backend/record", text: "检测记录", icon: "wq-sieve", children : [
            {to: "/backend/record/single", text: "单条检测", domestic: true},
            {to: "/backend/record/batch/0", text: "未检测列表"},
            {to: "/backend/record/batch/1", text: "检测中列表"},
            {to: "/backend/record/batch/2", text: "已检测列表"},
            {to: "/backend/record/batch/3", text: "检测异常列表", auth: [AUTH.SUPER_ADMIN, AUTH.ADMIN]},
            {to: "/backend/record/batch/9", text: "已关闭检测列表", auth: [AUTH.SUPER_ADMIN, AUTH.ADMIN]},
            {to: "/backend/record/statistics", text: "检测统计"},
            {to: "/backend/record/api/statistics", text: "通道统计", auth: [AUTH.SUPER_ADMIN]}
        ]
    },
    {to: "/backend/agent/return/list", text: "返佣记录", key: "return", icon: "wq-finance",  domestic: false, auth: [AUTH.AGENT]},
    {
        to: "/backend/channel", text: "通道和仓库", icon: "wq-api", auth: [AUTH.SUPER_ADMIN], children : [
            {to: "/backend/channel/api", text: "通道管理"},
            {to: "/backend/channel/store", text: "本地仓库"},
            {to: "/backend/channel/dataset", text: "仓库数据"},
            {to: "/backend/channel/upkeep", text: "仓库维护"},
            {to: "/backend/channel/search", text: "仓库查询"}
        ]
    },
    {
        to: "/backend/product", text: "产品管理", icon: "wq-chanpin", auth: [AUTH.ADMIN, AUTH.SUPER_ADMIN], children : [
            {to: "/backend/product/list", text: "产品列表", auth: [AUTH.ADMIN]},
            {to: "/backend/product/sort", text: "产品排序", auth: [AUTH.ADMIN]},
            {to: "/backend/product/channel", text: "产品通道配置", auth: [AUTH.SUPER_ADMIN]},
            {to: "/backend/product/price", text: "产品价格方案", auth: [AUTH.ADMIN]},
        ]
    },
    {
        to: "/backend/employee", text: "员工管理", icon: "wq-chanpin", auth: [AUTH.AGENT], children : [
            {to: "/backend/employee/list", text: "员工列表", auth: [AUTH.AGENT]},
            {to: "/backend/employee/achievement", text: "员工业绩", auth: [AUTH.AGENT]},
        ]
    },
    {
        to: "/backend/setting", text: "系统设置", icon: "wq-setting", auth: [AUTH.AGENT, AUTH.ADMIN], children : [
            {to: "/backend/setting/account", text: "账号管理", auth: AUTH.ADMIN},
            {to: "/backend/setting/sms/template", text: "短信模板", auth: AUTH.ADMIN},
            {to: "/backend/setting/sms/record", text: "短信记录", auth: AUTH.ADMIN},
            {to: "/backend/setting/website", text: "网站设置", auth: [AUTH.AGENT, AUTH.ADMIN]},
            {to: "/backend/setting/pay", text: "支付设置", auth: AUTH.AGENT},
            //{to: "/backend/setting/employee", text: "客服管理", auth: AUTH.AGENT},
            {to: "/backend/setting/package", text: "充值套餐", auth: AUTH.AGENT},
        ]
    },
    {
        to: "/backend/website", text: "网站设置", icon: "wq-setting", auth: AUTH.AGENT, key: "site", children : [
            {to: "/backend/website/tools", text: "外链工具"},
            {to: "/backend/website/news", text: "新闻动态"}
        ]
    }
]
